<template>
    <v-dialog v-model="finishDialog" max-width="400">
        <v-card>
            <v-card-title>Selesai tryout?</v-card-title>

            <v-card-text v-if="unanswered || flagged">
                <v-alert type="warning" border="left" colored-border>
                    Kamu masih punya

                    <template v-if="unanswered">
                        soal yang belum dijawab: {{ unanswered }}
                    </template>

                    <template v-if="flagged">
                        <template v-if="unanswered">
                            dan
                        </template>

                        soal yang masih ditandai: {{ flagged }}
                    </template>
                </v-alert>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="finishDialog = false" text>Batal</v-btn>
                <v-btn @click="finishTryout" text color="primary" :loading="$store.get('loader/loading', 'finishing')">Selesai</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { sync } from 'vuex-pathify'
import finishTryoutMixin from './finishTryoutMixin'

export default {
    mixins: [finishTryoutMixin],

    computed: {
        finishDialog: sync('tryout/finishDialog'),

        unanswered() {
            return this.$store.get('tryout/answers')
                .map((value, index) => {
                    return {
                        number: index + 1,
                        answered: !!value.answer_id
                    }
                })
                .filter(answer => ! answer.answered)
                .map(value => value.number)
                .join(', ')
        },

        flagged() {
            return this.$store.get('tryout/answers')
                .map((value, index) => {
                    return {
                        number: index + 1,
                        flagged: value.flagged
                    }
                })
                .filter(answer => answer.flagged)
                .map(value => value.number)
                .join(', ')
        }
    },
}
</script>
